export default __webpack_public_path__ + "static/tile_mobile-490df22c9de2310a8a84ab3d8b38bc3e.png";